// Map a signup email's domain to its webmail inbox so the post-signup
// "Check email" card can deep-link straight to where the verification
// email landed. Unknown domains return null — the card then renders
// without the shortcut (a mailto: would open a compose window, not the
// inbox, so there is no useful generic fallback).

interface MailProvider {
  label: string;
  url: string;
}

const GMAIL: MailProvider = { label: "Gmail", url: "https://mail.google.com" };
const OUTLOOK: MailProvider = {
  label: "Outlook",
  url: "https://outlook.live.com/mail",
};
const YAHOO: MailProvider = {
  label: "Yahoo Mail",
  url: "https://mail.yahoo.com",
};
const ICLOUD: MailProvider = {
  label: "iCloud Mail",
  url: "https://www.icloud.com/mail",
};
const PROTON: MailProvider = {
  label: "Proton Mail",
  url: "https://mail.proton.me",
};
const GMX: MailProvider = { label: "GMX", url: "https://www.gmx.net" };

const PROVIDERS: Record<string, MailProvider> = {
  "gmail.com": GMAIL,
  "googlemail.com": GMAIL,
  "outlook.com": OUTLOOK,
  "outlook.de": OUTLOOK,
  "hotmail.com": OUTLOOK,
  "hotmail.de": OUTLOOK,
  "live.com": OUTLOOK,
  "msn.com": OUTLOOK,
  "yahoo.com": YAHOO,
  "yahoo.de": YAHOO,
  "ymail.com": YAHOO,
  "icloud.com": ICLOUD,
  "me.com": ICLOUD,
  "mac.com": ICLOUD,
  "proton.me": PROTON,
  "protonmail.com": PROTON,
  "pm.me": PROTON,
  "gmx.de": GMX,
  "gmx.net": GMX,
  "gmx.com": GMX,
  "web.de": { label: "WEB.DE", url: "https://web.de" },
  "t-online.de": { label: "T-Online", url: "https://email.t-online.de" },
  "aol.com": { label: "AOL Mail", url: "https://mail.aol.com" },
  "zoho.com": { label: "Zoho Mail", url: "https://mail.zoho.com" },
  "fastmail.com": { label: "Fastmail", url: "https://app.fastmail.com" },
};

export function getMailProvider(email: string): MailProvider | null {
  const at = email.lastIndexOf("@");
  if (at < 0) return null;
  const domain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return PROVIDERS[domain] ?? null;
}
